// SchoolConfigPage.js
import React, { useState, useEffect } from 'react';
import { FormGroup, Input, Label, Button, Alert, Spinner, Card, CardBody, CardHeader, Table } from 'reactstrap';
import { toast } from 'react-toastify';
import API from '../../services/API';

const weekdays = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"];

const SchoolConfigPage = () => {
  const [config, setConfig] = useState({});
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(null);

  const [mcReasons, setMCReasons] = useState([]);
  const [loadingMC, setLoadingMC] = useState(true);
  const [mcError, setMCError] = useState(null);
  const [selectedMC, setSelectedMC] = useState('');


  // NEW: Activation Date state
  const [activationDate, setActivationDate] = useState('');
  const [loadingActivation, setLoadingActivation] = useState(true);
  const [activationLocked, setActivationLocked] = useState(false);

  // Add this new state
  const [hasAfternoonSession, setHasAfternoonSession] = useState(false);
  // 🔹 New state for MC Letter toggle
  const [mcLetterEnabled, setMcLetterEnabled] = useState(true);
  const [loadingMCLetter, setLoadingMCLetter] = useState(true);
  const [savingMCLetter, setSavingMCLetter] = useState(false);

  const [timetableEnabled, setTimetableEnabled] = useState(false);
  const [loadingTimetable, setLoadingTimetable] = useState(true);
  const [savingTimetable, setSavingTimetable] = useState(false);

  const [latecomerEmailEnabled, setLatecomerEmailEnabled] = useState(false);
  const [loadingLatecomerEmail, setLoadingLatecomerEmail] = useState(true);
  const [savingLatecomerEmail, setSavingLatecomerEmail] = useState(false);

  useEffect(() => {
    fetchConfig();
    getMCReasons();
    fetchDefaultMC();
    fetchActivationDate();
    fetchMCLetterConfig();
    fetchTimetableConfig();
      fetchLatecomerEmailConfig();
  }, []);
  const fetchLatecomerEmailConfig = async () => {
  setLoadingLatecomerEmail(true);

  try {
    const headers = {
      "Content-Type": "application/json",
      token: localStorage.getItem("token"),
    };

    const res = await API.get("/portal/attendance/latecomer-email-config", {
      headers,
    });

    if (res.data.response_code === 1000) {
      setLatecomerEmailEnabled(
        !!res.data.data?.send_latecomer_email_to_teacher
      );
    } else {
      toast.error(res.data.message || "Failed to load latecomer email config");
    }
  } catch (err) {
    console.log(err);
    toast.error("Error loading latecomer email config");
  } finally {
    setLoadingLatecomerEmail(false);
  }
};

const saveLatecomerEmailConfig = async (enabled) => {
  setSavingLatecomerEmail(true);

  try {
    const headers = {
      "Content-Type": "application/json",
      token: localStorage.getItem("token"),
    };

    const res = await API.post(
      "/portal/attendance/latecomer-email-config",
      {
        send_latecomer_email_to_teacher: enabled,
      },
      { headers }
    );

    if (res.data.response_code === 1000) {
      setLatecomerEmailEnabled(enabled);
      toast.success("Latecomer teacher email setting updated!");
    } else {
      toast.error(
        res.data.message || "Failed to save latecomer email setting"
      );
    }
  } catch (err) {
    console.log(err);
    toast.error("Error updating latecomer email setting");
  } finally {
    setSavingLatecomerEmail(false);
  }
};
  const fetchTimetableConfig = async () => {
    setLoadingTimetable(true);

    try {
      const headers = {
        "Content-Type": "application/json",
        token: localStorage.getItem("token")
      };

      const res = await API.get("/timetable/enabled", { headers });
      if (res.data.response_code === 1000) {
        setTimetableEnabled(res.data.data.enabled);
      } else {
        toast.error(res.data.message || "Failed to load timetable config");
      }
    } catch (err) {
      console.log(err)
      toast.error("Error loading timetable config");
    } finally {
      setLoadingTimetable(false);
    }
  };
  const saveTimetableConfig = async (enabled) => {
    setSavingTimetable(true);

    try {
      const headers = {
        "Content-Type": "application/json",
        token: localStorage.getItem("token")
      };

      const res = await API.post("/timetable/enabled", { enabled }, { headers });

      if (res.data.response_code === 1000) {
        setTimetableEnabled(enabled);
        toast.success("Timetable setting updated!");
      } else {
        toast.error(res.data.message || "Failed to save timetable setting");
      }
    } catch (err) {
      toast.error("Error updating timetable setting");
    } finally {
      setSavingTimetable(false);
    }
  };

  // 🔹 Fetch MC Letter configuration
  const fetchMCLetterConfig = async () => {
    setLoadingMCLetter(true);
    try {
      const headers = { 'Content-Type': 'application/json', token: localStorage.getItem('token') };
      const res = await API.get('/portal/attendance/mcLetterConfig', { headers });

      if (res.data.response_code === 1000 && res.data.data) {
        setMcLetterEnabled(res.data.data.mc_letter_enabled);
      } else {
        toast.error(res.data.message || "Failed to load MC Letter configuration");
      }
    } catch (err) {
      toast.error("Error fetching MC Letter configuration");
    } finally {
      setLoadingMCLetter(false);
    }
  };

  // 🔹 Save MC Letter configuration
  const saveMCLetterConfig = async (enabled) => {
    setSavingMCLetter(true);
    try {
      const headers = { 'Content-Type': 'application/json', token: localStorage.getItem('token') };
      const res = await API.post('/portal/attendance/mcLetterConfig', { mc_letter_enabled: enabled }, { headers });
      if (res.data.response_code === 1000) {
        setMcLetterEnabled(enabled);
        toast.success("MC Letter setting updated successfully");
      } else {
        toast.error(res.data.message || "Failed to update MC Letter setting");
      }
    } catch (err) {
      toast.error("Error updating MC Letter setting");
    } finally {
      setSavingMCLetter(false);
    }
  };

  // Fetch config
  const fetchConfig = async () => {
    setLoading(true);
    try {
      const headers = { 'Content-Type': 'application/json', token: localStorage.getItem('token') };

      // Morning config
      const morningRes = await API.get('/portal/attendance/config', { headers });
      let morningData = {};
      if (morningRes.data.response_code === 1000) {
        morningData = morningRes.data.data || {};
      }

      let merged = { ...morningData };

      // Afternoon config
      let hasAfternoon = false;
      try {
        const afternoonRes = await API.get('/portal/attendance/afternoonConfig', { headers });
        if (afternoonRes.data.response_code === 1000) {
          const afternoonData = afternoonRes.data.data || {};
          const defaults = afternoonData["default"] || {};

          weekdays.forEach((_, idx) => {
            const perDay = afternoonData[String(idx)] || {};
            const mergedDay = { ...defaults, ...perDay }; // default fallback
            Object.entries(mergedDay).forEach(([k, v]) => {
              merged[`${k}_${idx}`] = v;
            });
          });

          hasAfternoon = true;
        } else if (afternoonRes.data.response_code === 4004) {
          // School has no afternoon session
          hasAfternoon = false;
        }
      } catch (err) {
        console.log("No afternoon session available or API error:", err);
        hasAfternoon = false;
      }

      setHasAfternoonSession(hasAfternoon);


      setConfig(merged);

      if (morningData.mc_category) {
        setSelectedMC(`${morningData.mc_category}|||${morningData.mc_sub_category || ''}`);
      }
    } catch (err) {
      setError("Failed to load config");
    } finally {
      setLoading(false);
    }
  };
  const fetchActivationDate = async () => {
    setLoadingActivation(true);
    try {
      const headers = { 'Content-Type': 'application/json', token: localStorage.getItem('token') };
      const res = await API.get('/portal/schoolActivation', { headers });
      if (res.data.response_code === 1000 && res.data.data?.activation_date) {
        setActivationDate(res.data.data.activation_date.split('T')[0]);
        setActivationLocked(true); // Lock if already configured
      } else {
        setActivationLocked(false); //Allow new input
      }
    } catch {
      toast.error("Failed to load activation date");
    } finally {
      setLoadingActivation(false);
    }
  };

  // 🔹 NEW: Save school activation date
  const saveActivationDate = async () => {
    if (!activationDate) {
      toast.error("Please select an activation date.");
      return;
    }

    // Validation: cannot set past date or more than 1 year ahead
    const today = new Date();
    const selected = new Date(activationDate);
    const oneYearLater = new Date(today);
    oneYearLater.setFullYear(today.getFullYear() + 1);

    if (selected < today.setHours(0, 0, 0, 0)) {
      toast.error("Activation date cannot be in the past.");
      return;
    }
    if (selected > oneYearLater) {
      toast.error("Activation date cannot be more than 1 year ahead.");
      return;
    }

    setSaving(true);
    try {
      const headers = { 'Content-Type': 'application/json', token: localStorage.getItem('token') };
      const res = await API.post('/portal/schoolActivation', { activation_date: activationDate }, { headers });
      if (res.data.response_code === 1000) {
        toast.success("Activation date updated!");
      } else {
        toast.error(res.data.message || "Failed to update activation date");
      }
    } catch (err) {
      toast.error("Error saving activation date");
    } finally {
      setSaving(false);
    }
  };

  // Save all config
  const saveAll = async (isAfternoon = false) => {
    setSaving(true);
    try {
      const headers = { 'Content-Type': 'application/json', token: localStorage.getItem('token') };
      const payloads = [];

      if (!isAfternoon) {
        // Morning config
        ["early_cutoff", "late_after"].forEach(field => {
          const value = config[field];
          if (value && value.includes(":")) {
            const [hour, minute] = value.split(":").map(Number);
            payloads.push(API.post("/portal/attendance/config", {
              updated_field: field,
              value,         // keep raw for fallback
              hour,
              minute
            }, { headers }));
          }
        });
      } else {
        // Afternoon config (Mon–Fri)
        weekdays.forEach((_, idx) => {
          ["early_cutoff_afternoon", "late_after_afternoon"].forEach(field => {
            const key = `${field}_${idx}`;
            const value = config[key];
            if (value && value.includes(":")) {
              const [hour, minute] = value.split(":").map(Number);
              payloads.push(API.post("/portal/attendance/afternoonConfig", {
                updated_field: field,
                value,         // keep raw for fallback
                hour,
                minute,
                day_of_week: Number(idx)

              }, { headers }));
            }
          });
        });
      }

      const results = await Promise.all(payloads);

      // check failures
      results.forEach(res => {
        if (res.data?.response_code !== 1000) {
          throw new Error(res.data?.message || "Save failed");
        }
      });
      toast.success(isAfternoon ? "Afternoon config saved!" : "Morning config saved!");
      fetchConfig();
    } catch (err) {
      console.error("Save error", err);
      setError("Failed to save config");
    } finally {
      setSaving(false);
    }
  };


  // Fetch MC reasons
  const getMCReasons = async () => {
    setLoadingMC(true);
    try {
      const response = await fetch("https://api.schoolpay.tech/attendance/absenceReason");
      const resJSON = await response.json();
      if (resJSON.response_code === 1000) setMCReasons(resJSON.data);
      else setMCError(resJSON.message);
    } catch {
      setMCError("Failed to load MC reasons");
    } finally {
      setLoadingMC(false);
    }
  };

  const fetchDefaultMC = async () => {
    try {
      const headers = { 'Content-Type': 'application/json', token: localStorage.getItem('token') };
      const res = await API.get('/portal/attendance/mcConfig', { headers });
      if (res.data.response_code === 1000) {
        setConfig(cfg => ({
          ...cfg,
          mc_category: res.data.data.category || '',
          mc_sub_category: res.data.data.sub_category || '',
        }));
        if (res.data.data.category) {
          setSelectedMC(`${res.data.data.category}|||${res.data.data.sub_category || ''}`);
        }
      }
    } catch {
      setError("Failed to load MC default");
    }
  };

  const saveDefaultMC = async (e) => {
    e.preventDefault();
    if (!selectedMC) {
      toast.error("Please select a default MC Reason.");
      return;
    }
    const [mc_category, mc_sub_category] = selectedMC.split("|||");
    setSaving(true);
    try {
      const headers = { 'Content-Type': 'application/json', token: localStorage.getItem('token') };
      const res = await API.post('/portal/attendance/mcConfig', { category: mc_category, sub_category: mc_sub_category }, { headers });
      console.log(res)
      if (res.data.response_code === 1000) {
        toast.success("MC Reason saved!");
        setConfig(cfg => ({ ...cfg, mc_category, mc_sub_category }));
      } else {
        setError(res.data.message);
      }
    } catch {
      setError("Failed to save MC reason");
    } finally {
      setSaving(false);
    }
  };
  const ToggleSwitch = ({ enabled, loading, saving, onToggle }) => {
    if (loading) return <Spinner size="sm" />;

    return (
      <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
        <div
          onClick={() => {
            if (!saving) onToggle();
          }}
          style={{
            width: 54,
            height: 30,
            borderRadius: 999,
            padding: 3,
            background: enabled ? "#16a34a" : "#d1d5db",
            cursor: saving ? "not-allowed" : "pointer",
            opacity: saving ? 0.65 : 1,
            transition: "all 0.2s ease",
            boxShadow: enabled
              ? "0 8px 18px rgba(22,163,74,0.25)"
              : "inset 0 0 0 1px rgba(0,0,0,0.04)",
          }}
        >
          <div
            style={{
              width: 24,
              height: 24,
              borderRadius: "50%",
              background: "#fff",
              transform: enabled ? "translateX(24px)" : "translateX(0)",
              transition: "transform 0.2s ease",
              boxShadow: "0 2px 8px rgba(15,23,42,0.18)",
            }}
          />
        </div>

        <div>
          <div
            style={{
              fontWeight: 800,
              color: enabled ? "#15803d" : "#6b7280",
              lineHeight: 1,
            }}
          >
            {enabled ? "Enabled" : "Disabled"}
          </div>

          {saving && (
            <div style={{ fontSize: 12, color: "#94a3b8", marginTop: 4 }}>
              Saving...
            </div>
          )}
        </div>
      </div>
    );
  };

  const SectionCard = ({ title, subtitle, badge, children }) => (
    <Card
      style={{
        border: "1px solid #e5e7eb",
        borderRadius: 22,
        boxShadow: "0 16px 40px rgba(15,23,42,0.06)",
        overflow: "hidden",
        marginBottom: 22,
        background: "#fff",
      }}
    >
      <CardHeader
        style={{
          background: "#fff",
          borderBottom: "1px solid #eef2f7",
          padding: "20px 24px",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            gap: 16,
            alignItems: "flex-start",
          }}
        >
          <div>
            <div style={{ fontSize: 18, fontWeight: 900, color: "#0f172a" }}>
              {title}
            </div>

            {subtitle && (
              <div
                style={{
                  marginTop: 4,
                  fontSize: 13,
                  color: "#64748b",
                  lineHeight: 1.5,
                }}
              >
                {subtitle}
              </div>
            )}
          </div>

          {badge && (
            <span
              style={{
                background: "#f8fafc",
                border: "1px solid #e2e8f0",
                color: "#475569",
                borderRadius: 999,
                padding: "7px 12px",
                fontSize: 12,
                fontWeight: 800,
                whiteSpace: "nowrap",
              }}
            >
              {badge}
            </span>
          )}
        </div>
      </CardHeader>

      <CardBody style={{ padding: 24 }}>{children}</CardBody>
    </Card>
  );

  const SettingRow = ({ title, description, right }) => (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        gap: 20,
        padding: "18px 0",
        borderBottom: "1px solid #f1f5f9",
      }}
    >
      <div style={{ maxWidth: 720 }}>
        <div style={{ fontSize: 15, fontWeight: 850, color: "#111827" }}>
          {title}
        </div>

        {description && (
          <div
            style={{
              marginTop: 5,
              fontSize: 13,
              color: "#64748b",
              lineHeight: 1.55,
            }}
          >
            {description}
          </div>
        )}
      </div>

      <div style={{ flex: "0 0 auto" }}>{right}</div>
    </div>
  );
return (
  <div
    style={{
      minHeight: "100vh",
      background: "#f8fafc",
      padding: "28px 24px",
    }}
  >
    <div style={{ maxWidth: 1180, margin: "0 auto" }}>
      <div
        style={{
          background: "linear-gradient(135deg, #0f172a 0%, #1e293b 55%, #991b1b 100%)",
          borderRadius: 28,
          padding: "34px 36px",
          marginBottom: 24,
          color: "#fff",
          position: "relative",
          overflow: "hidden",
          boxShadow: "0 24px 70px rgba(15,23,42,0.18)",
        }}
      >
        <div
          style={{
            position: "absolute",
            right: -80,
            top: -80,
            width: 260,
            height: 260,
            borderRadius: "50%",
            background: "rgba(255,255,255,0.08)",
          }}
        />

        <div style={{ position: "relative", zIndex: 1 }}>
          <div
            style={{
              display: "inline-flex",
              alignItems: "center",
              gap: 8,
              background: "rgba(255,255,255,0.12)",
              border: "1px solid rgba(255,255,255,0.18)",
              borderRadius: 999,
              padding: "8px 13px",
              fontSize: 12,
              fontWeight: 800,
              textTransform: "uppercase",
              letterSpacing: 0.5,
              marginBottom: 14,
            }}
          >
            MYSP AI School Settings
          </div>

          <h1
            style={{
              fontSize: "clamp(30px, 4vw, 48px)",
              fontWeight: 950,
              letterSpacing: -1.4,
              margin: 0,
            }}
          >
            Attendance Configuration
          </h1>

          <p
            style={{
              maxWidth: 760,
              margin: "10px 0 0",
              color: "rgba(255,255,255,0.76)",
              fontSize: 15,
              lineHeight: 1.7,
            }}
          >
            Manage attendance cut-off times, MC settings, teacher alerts,
            timetable access, and school activation settings from one place.
          </p>
        </div>
      </div>

      {error && (
        <Alert color="danger" style={{ borderRadius: 16 }}>
          {error}
        </Alert>
      )}

      <div
        style={{
          display: "grid",
          gridTemplateColumns: "minmax(0, 1.35fr) minmax(320px, 0.65fr)",
          gap: 22,
          alignItems: "start",
        }}
      >
        <div>
          <SectionCard
            title="Morning Attendance"
            subtitle="Configure the standard morning attendance timing used for early and late detection."
            badge="Core"
          >
            {loading ? (
              <div style={{ textAlign: "center", padding: 40 }}>
                <Spinner />
              </div>
            ) : (
              <>
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
                    gap: 18,
                    marginBottom: 22,
                  }}
                >
                  <FormGroup>
                    <Label style={{ fontWeight: 800, color: "#334155" }}>
                      Early Cutoff
                    </Label>
                    <Input
                      type="time"
                      value={config.early_cutoff || ""}
                      onChange={(e) =>
                        setConfig({ ...config, early_cutoff: e.target.value })
                      }
                      style={{
                        borderRadius: 14,
                        minHeight: 46,
                        borderColor: "#e2e8f0",
                      }}
                    />
                  </FormGroup>

                  <FormGroup>
                    <Label style={{ fontWeight: 800, color: "#334155" }}>
                      Late After
                    </Label>
                    <Input
                      type="time"
                      value={config.late_after || ""}
                      onChange={(e) =>
                        setConfig({ ...config, late_after: e.target.value })
                      }
                      style={{
                        borderRadius: 14,
                        minHeight: 46,
                        borderColor: "#e2e8f0",
                      }}
                    />
                  </FormGroup>
                </div>

                <Button
                  color="primary"
                  disabled={saving}
                  onClick={() => saveAll(false)}
                  style={{
                    borderRadius: 14,
                    fontWeight: 800,
                    padding: "11px 18px",
                  }}
                >
                  {saving ? "Saving..." : "Save Morning Configuration"}
                </Button>
              </>
            )}
          </SectionCard>

          {hasAfternoonSession && (
            <SectionCard
              title="Afternoon Attendance"
              subtitle="Configure different afternoon cut-off timings for each weekday."
              badge="Afternoon Session"
            >
              <div
                style={{
                  border: "1px solid #e5e7eb",
                  borderRadius: 18,
                  overflow: "hidden",
                }}
              >
                <Table responsive hover style={{ marginBottom: 0 }}>
                  <thead style={{ background: "#f8fafc" }}>
                    <tr>
                      <th style={{ color: "#64748b", fontSize: 12 }}>Day</th>
                      <th style={{ color: "#64748b", fontSize: 12 }}>
                        Early Cutoff
                      </th>
                      <th style={{ color: "#64748b", fontSize: 12 }}>
                        Late After
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {weekdays.map((day, idx) => (
                      <tr key={idx}>
                        <td style={{ fontWeight: 800, color: "#0f172a" }}>
                          {day}
                        </td>
                        <td>
                          <Input
                            type="time"
                            value={config[`early_cutoff_afternoon_${idx}`] || ""}
                            onChange={(e) =>
                              setConfig({
                                ...config,
                                [`early_cutoff_afternoon_${idx}`]: e.target.value,
                              })
                            }
                            style={{ borderRadius: 12 }}
                          />
                        </td>
                        <td>
                          <Input
                            type="time"
                            value={config[`late_after_afternoon_${idx}`] || ""}
                            onChange={(e) =>
                              setConfig({
                                ...config,
                                [`late_after_afternoon_${idx}`]: e.target.value,
                              })
                            }
                            style={{ borderRadius: 12 }}
                          />
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </div>

              <Button
                color="primary"
                disabled={saving}
                onClick={() => saveAll(true)}
                style={{
                  borderRadius: 14,
                  fontWeight: 800,
                  padding: "11px 18px",
                  marginTop: 18,
                }}
              >
                {saving ? "Saving..." : "Save Afternoon Configuration"}
              </Button>
            </SectionCard>
          )}

          <SectionCard
            title="MC & Absence Rules"
            subtitle="Set default MC reasons and control whether supporting MC documents are required."
            badge="Medical"
          >
            <div style={{ marginBottom: 22 }}>
              <div style={{ fontSize: 15, fontWeight: 900, color: "#111827" }}>
                Default MC / Absent Reason
              </div>

              {mcError && (
                <Alert color="danger" style={{ marginTop: 12, borderRadius: 14 }}>
                  {mcError}
                </Alert>
              )}

              {loadingMC ? (
                <Spinner size="sm" style={{ marginTop: 14 }} />
              ) : (
                <form
                  onSubmit={saveDefaultMC}
                  style={{
                    display: "grid",
                    gridTemplateColumns: "minmax(260px, 1fr) auto",
                    gap: 12,
                    alignItems: "end",
                    marginTop: 14,
                  }}
                >
                  <FormGroup style={{ marginBottom: 0 }}>
                    <Label style={{ fontWeight: 800, color: "#334155" }}>
                      Select Default Reason
                    </Label>
                    <Input
                      type="select"
                      value={selectedMC}
                      onChange={(e) => setSelectedMC(e.target.value)}
                      style={{ borderRadius: 14, minHeight: 46 }}
                    >
                      <option value="">-- Please select --</option>
                      {mcReasons.map((r) => (
                        <option
                          key={r.reason_id}
                          value={`${r.name}|||${r.sub_reason || ""}`}
                        >
                          {r.name}
                          {r.sub_reason ? ` — ${r.sub_reason}` : ""}
                        </option>
                      ))}
                    </Input>
                  </FormGroup>

                  <Button
                    color="success"
                    disabled={saving}
                    type="submit"
                    style={{ borderRadius: 14, fontWeight: 800, minHeight: 46 }}
                  >
                    Save Default
                  </Button>
                </form>
              )}

              {config.mc_category && (
                <div
                  style={{
                    marginTop: 14,
                    background: "#f8fafc",
                    border: "1px solid #e5e7eb",
                    borderRadius: 14,
                    padding: "12px 14px",
                    color: "#334155",
                    fontSize: 13,
                    fontWeight: 600,
                  }}
                >
                  Saved Default: <b>{config.mc_category}</b>
                  {config.mc_sub_category ? ` — ${config.mc_sub_category}` : ""}
                </div>
              )}
            </div>

            <SettingRow
              title="Require MC Letter Upload"
              description="When enabled, students and teachers must upload an MC letter for medical absences."
              right={
                <ToggleSwitch
                  enabled={mcLetterEnabled}
                  loading={loadingMCLetter}
                  saving={savingMCLetter}
                  onToggle={() => saveMCLetterConfig(!mcLetterEnabled)}
                />
              }
            />
          </SectionCard>
        </div>

        <div>
          <SectionCard
            title="Automation & Alerts"
            subtitle="Control automated features used by the school."
            badge="Automation"
          >
            <SettingRow
              title="Latecomer Teacher Email"
              description="Automatically email class teachers or guru when students are late today. Morning and afternoon reports can be sent separately by scheduler."
              right={
                <ToggleSwitch
                  enabled={latecomerEmailEnabled}
                  loading={loadingLatecomerEmail}
                  saving={savingLatecomerEmail}
                  onToggle={() =>
                    saveLatecomerEmailConfig(!latecomerEmailEnabled)
                  }
                />
              }
            />

            <SettingRow
              title="Enable Timetable"
              description="Allow users to access timetable features from the application."
              right={
                <ToggleSwitch
                  enabled={timetableEnabled}
                  loading={loadingTimetable}
                  saving={savingTimetable}
                  onToggle={() => saveTimetableConfig(!timetableEnabled)}
                />
              }
            />
          </SectionCard>

          <SectionCard
            title="School Activation"
            subtitle="Control when the school system becomes active."
            badge={activationLocked ? "Locked" : "Editable"}
          >
            {loadingActivation ? (
              <Spinner size="sm" />
            ) : (
              <>
                <FormGroup>
                  <Label style={{ fontWeight: 800, color: "#334155" }}>
                    Activation Date
                  </Label>
                  <Input
                    type="date"
                    value={activationDate || ""}
                    onChange={(e) => setActivationDate(e.target.value)}
                    disabled={activationLocked}
                    style={{
                      borderRadius: 14,
                      minHeight: 46,
                      borderColor: "#e2e8f0",
                    }}
                  />
                </FormGroup>

                <Button
                  color="success"
                  disabled={saving || activationLocked}
                  onClick={saveActivationDate}
                  style={{
                    borderRadius: 14,
                    fontWeight: 800,
                    padding: "10px 16px",
                  }}
                >
                  Save Activation Date
                </Button>

                {activationDate && (
                  <div
                    style={{
                      marginTop: 14,
                      background: activationLocked ? "#f8fafc" : "#ecfdf5",
                      border: "1px solid #e5e7eb",
                      borderRadius: 14,
                      padding: 14,
                    }}
                  >
                    <div style={{ fontWeight: 800, color: "#0f172a" }}>
                      Configured date: {activationDate}
                    </div>
                    <div
                      style={{
                        marginTop: 4,
                        color: "#64748b",
                        fontSize: 13,
                        lineHeight: 1.5,
                      }}
                    >
                      {activationLocked
                        ? "Contact your system administrator if you need to change the activation date."
                        : "This date will be used to activate the school system."}
                    </div>
                  </div>
                )}
              </>
            )}
          </SectionCard>
        </div>
      </div>
    </div>
  </div>
);
};

export default SchoolConfigPage;
